
// /// COOKIES VERSION 
// import axios from "axios";

// console.log('AXIOS INTERCEPTOR');

// const api = axios.create({
//     baseURL: process.env.REACT_APP_NETLIFY_API_URL || process.env.REACT_APP_API_URL,
//     withCredentials: true,
// });

// let isUnauthorizedHandled = false;

// api.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         const authenticated = sessionStorage.getItem('isAuthenticated'); // Get the current auth status

//         console.log('Error: ', error);

//         // Check 1: Is there an error response?
//         // Check 2: Is the error status 401 (Unauthorized)?
//         // Check 3: Does sessionStorage indicate the user was previously authenticated?
//         // Check 4: Has this specific unauthorized event *not* been handled yet?
//         if (
//             error.response &&
//             error.response.status === 401 &&
//             authenticated === 'true' && // Ensure it's the string 'true'
//             !isUnauthorizedHandled // Crucial: Only proceed if we haven't handled it
//         ) {
//             isUnauthorizedHandled = true; // Set the flag immediately to prevent further handling

//             // Optional: Clear authentication status in sessionStorage immediately
//             // This is good practice even though the redirect will effectively clear everything.
//             sessionStorage.removeItem('isAuthenticated'); // Or set to 'false' if you prefer

//             alert("Your session has expired. Please log in again.");

//             // Use a short delay to allow the alert to be seen
//             setTimeout(() => {
//                 window.location.href = "/login"; // Redirect to login page
//             }, 100); // 500ms delay

//             // If you have a centralized logout function that clears user data and state:
//             // triggerLogout();
//         }

//         // Always reject the promise so that the component making the API call
//         // can handle the error (e.g., display an error message, stop a loader).
//         return Promise.reject(error);
//     }
// );

// export default api;

import axios from "axios";

const baseUrlStr = process.env.REACT_APP_NETLIFY_API_URL || process.env.REACT_APP_API_URL;
const api = axios.create({
    baseURL: baseUrlStr,
    withCredentials: true,
});

const isPublicAuthRequest = (config) => {
    const url = config?.url || "";
    return (
        url.includes("/login/") ||
        url.includes("/create-user/") ||
        url.includes("/reset-password")
    );
};

api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Login/auth failures also return 401 — don't treat those as an expired session
        if (error.response?.status === 401 && !isPublicAuthRequest(error.config)) {
            if (error.response?.data?.data === "No token provided") {
                window.dispatchEvent(new CustomEvent('auth:expired-token'));
            } else {
                window.dispatchEvent(new CustomEvent('auth:expired'));
            }
        }
        return Promise.reject(error);
    }
);

export default api;